// $(".hours-alert-message-yellow").insertAfter("#productionSettings h3");
// tooltips
// $('#js-new-tooltip').click(function () {
//     $(".tooltip").toggle("fast");
// });

// Move user-based quote information out of Calculator
// $('#theQuote').contents().clone().appendTo('.js-quoteMove');

// Move #turnaroundProcess to .productionGroup
// $('#turnaroundProcess').contents().prependTo('.productionGroup');

// Strip carrots(») off Add to/Update Cart Button
var cartButton = document.querySelector('.quoteContinue > button');
var newValue = cartButton.textContent.replace(' »', '');
cartButton.innerHTML = newValue;

// Move dynamic button out of Calculator
// $('.quoteContinue').contents().clone().appendTo('.js-buttonMove').removeClass('continueButton').addClass('btn btn_cta')

// Move lfVariousSettings inside lfConstruction
$('#lfVariousSettings').contents().appendTo('#lfConstruction');

$( window ).load(function() {
    // Rename certain h3
    $("h3:contains(Paper)").text("Printing");
    $("h3:contains(Production)").text("Turnaround");
    $("h3:contains(Materials)").text("Printing");

    // Move product unit cost
    //$('#productUnitCost').insertAfter('table.quote').show();

    // Move printSettingsGroup
    $('.printSettingsGroup').insertBefore('.paperGroup:first-of-type');

    // Move additionalProductFields inside finishingOptions
    $('#additionalProductFields').appendTo('#finishingOptions');
});

// Highlight phase in visual when select is hovered
$("#proofsDiv").hover(
    function () {
        $(".turnaroundTime-timeline_proofing").addClass("turnaroundTime-timeline_hover");
    },
    function () {
        $(".turnaroundTime-timeline_proofing").removeClass("turnaroundTime-timeline_hover");
    }
);
$("#turnaroundTimesDiv").hover(
    function () {
        $(".turnaroundTime-timeline_production").addClass("turnaroundTime-timeline_hover");
    },
    function () {
        $(".turnaroundTime-timeline_production").removeClass("turnaroundTime-timeline_hover");
    }
);

// turnaround message toggle
$('.js-turnaroundMessage-toggle').click(function (event) {
    event.preventDefault();
    $(".turnaroundMessage-paragraph").slideToggle("fast");
});

//move direct mail cta above calc footer
$( ".estimate-postage-cta-wrapper" ).insertAfter( "#turnaroundTimesDiv" );

// Adding DM mail options to
$('#mailOptions').insertBefore("#printSettings > #paper");

//Product Schema FAQs
setTimeout( () => { 
  
    if(!document.querySelector('.quarantine_faqs')){
        return;
    }

    const script = document.createElement("script");
    script.type = "application/ld+json";
    const captureFAQs = document.querySelector('.quarantine_faqs');
    const dt = captureFAQs.querySelectorAll('dt');
    const dd = captureFAQs.querySelectorAll('dd');
    const answers = [];
    const mainEntity = [];


    dd.forEach( ( e, i ) => {
        let captureP = []

        if(e.textContent.includes('ul')){
            Array.prototype.slice.call(e.querySelectorAll('li')).forEach( d => {
                captureP.push(d.textContent)
            })
        } else {
            Array.prototype.slice.call(e.querySelectorAll('p')).forEach( d => {
                captureP.push(d.textContent)
            })
        }
        answers[i] = captureP.join()
    });

    dt.forEach( (e, i) => {
        mainEntity.push({"@type": "Question","name": e.textContent.trim(), "acceptedAnswer": {"@type": "Answer", "text": `${answers[i]}`}})
    });

    script.innerHTML = `{"@context": "https://schema.org", "@type": "FAQPage", "mainEntity": ${JSON.stringify(mainEntity)} }`;
    document.head.appendChild(script);
    
}, 2100);
